document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header');
    const headerSixth = document.querySelector('.header-six');
    const sectionFirst = document.querySelector('section');
    const content = document.querySelector('.margin');
    const containers = document.querySelectorAll('.container');
    const main = document.querySelector('main');

    if (header) {
        function updateContentPadding() {
            const headerHeight = header.offsetHeight;
            const contentPaddingTop = headerHeight + 40;
            if (sectionFirst) {
                if (sectionFirst.classList.contains('not-found-section')) {
                    sectionFirst.style.paddingTop = `${headerHeight + 10}px`;
                } else if (sectionFirst && !sectionFirst.classList.contains('banner') && !sectionFirst.classList.contains('not-found-section')) {
                    main.style.paddingTop = `${contentPaddingTop}px`;
                }

                if (content && (header.classList.contains('header-one') || header.classList.contains('header-two') || header.classList.contains('header-six'))) {
                    if (sectionFirst.classList.contains('banner')) {
                        content.style.paddingTop = `${contentPaddingTop}px`;
                    }
                } else {
                    if (sectionFirst.classList.contains('section-banner-one') || sectionFirst.classList.contains('section-banner-two')) {
                        main.style.paddingTop = `${headerHeight}px`;
                    } else if (sectionFirst.classList.contains('banner') && !sectionFirst.classList.contains('section-banner-one') && !sectionFirst.classList.contains('section-banner-two')) {
                        main.style.paddingTop = `${contentPaddingTop}px`;
                    }
                }
            }
        }

        updateContentPadding();
        if (sectionFirst && !sectionFirst.classList.contains('section-banner-one') && !sectionFirst.classList.contains('section-banner-two')) {
            window.addEventListener('resize', updateContentPadding);
        }
    }

    if (headerSixth) {
        function updateContentPaddingLeft() {
            const MaxWidth = document.querySelector('.max-width');

            containers.forEach(container => {
                container.style.paddingLeft = '85px';
                if (MaxWidth) {
                    MaxWidth.style.paddingLeft = '65px';
                }
                if (window.innerWidth <= 480) {
                    container.style.paddingLeft = '15px';
                    if (MaxWidth) {
                        MaxWidth.style.paddingLeft = '0';
                    }
                }
            });
        }

        updateContentPaddingLeft();
        window.addEventListener("resize", updateContentPaddingLeft());
    }
});